export default {
  'Add Cut': 'Aggiungi Taglio',
}